import { render } from "./affiliate-self-assessment.view.vue?vue&type=template&id=7c1d102e&scoped=true&ts=true"
import script from "./affiliate-self-assessment.view.vue?vue&type=script&lang=ts"
export * from "./affiliate-self-assessment.view.vue?vue&type=script&lang=ts"

import "./affiliate-self-assessment.view.vue?vue&type=style&index=0&id=7c1d102e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1d102e"]])

export default __exports__